import {XauditModel} from '../../../models/xaudit.model';
import {TreatmentEndoDataModel} from './treatment-endo-data.model';

export class TreatmentEndoPerforationDataModel extends XauditModel {
  TretmentPerfID: string;
  TreatmentID: string;
  CaseWorkItemToothId: string;
  enumEndoPerfClassTypeID: string;
  enumToothCanalID: string;
  enumEndoPerfCrestalID: string;
  enumEndoPerfSizeID: string;
  enumEndoPerfTypeID: string;
  enumEndoPerfCausedByID: string;
  enumEndoPerfPriorRepaireID: string;
  enumEndoPerfTimeSincePerfID: string;
  enumEndoPerfRepairMaterialID: string;
  isPerfRadioDiscern: boolean;
  isPerfClinicallyDiscern: boolean;
  isPerfSurgicallyAccessible: boolean;

  dataTreatmentEndo: TreatmentEndoDataModel;
}
